import { useEffect } from 'react'

const useDocumentTitle = (title, skip) => {
  useEffect(() => {
    if (!skip) {
      document.title = `${title} - Metadata`
    }
  }, [skip, title])
}

export default useDocumentTitle
